import { useState } from "react";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { ContentCard } from "@/components/content/ContentCard";
import { CONTENT_CATEGORIES } from "@/config/site";
import { MEDIA } from "@/config/media";
import { cn } from "@/lib/utils";

const CONTENT_ITEMS = CONTENT_CATEGORIES.map((category) => ({ category, image: MEDIA.contentThumbnails[category] }));

export default function Content() {
  const [activeCategory, setActiveCategory] = useState("All");
  const filtered = activeCategory === "All" ? CONTENT_ITEMS : CONTENT_ITEMS.filter((i) => i.category === activeCategory);

  return (
    <div data-testid="content-page">
      <SEO
        title="Women's Football Content & Highlights"
        description="Match commentary, interviews, highlights and behind-the-scenes content covering grassroots women's football, from WomensMatchDayLive."
        path="/content"
      />
      <PageHero eyebrow="Content" title="Content" subtitle="Commentary, interviews, highlights and behind-the-scenes coverage." crumbLabel="Content" />

      <section className="bg-white py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-12">
          <div className="flex flex-wrap gap-2">
            {["All", ...CONTENT_CATEGORIES].map((category) => (
              <button
                key={category}
                type="button"
                data-testid={`content-filter-${category.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setActiveCategory(category)}
                className={cn(
                  "border px-4 py-2 font-subheading text-xs font-semibold uppercase tracking-wide transition-colors",
                  activeCategory === category ? "border-brand-purple bg-brand-purple text-white" : "border-border-light text-brand-black/60 hover:border-brand-purple"
                )}
              >
                {category}
              </button>
            ))}
          </div>

          <div data-testid="content-grid" className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((item, i) => (
              <Reveal key={item.category} delay={i * 0.05}>
                <ContentCard item={item} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
